import React from 'react';
import type { PartStripView } from '../../turncard/viewModel';
import { INTERFACE_TEXT } from '../../constants/interfaceText';
import styles from './PartsStrip.module.css';

const STATE_TEXT = {
  done: INTERFACE_TEXT.tsPartDone,
  current: INTERFACE_TEXT.tsPartCurrent,
  todo: INTERFACE_TEXT.tsPartTodo,
} as const;

/** Where the learner is in the lesson: one segment per part, or a caption when there are many. */
export const PartsStrip: React.FC<{ strip: PartStripView }> = ({ strip }) => {
  if (strip.parts.length === 0) return null;
  if (strip.caption) {
    return (
      <p className={styles.caption} data-testid="parts-caption">
        {strip.caption}
      </p>
    );
  }
  return (
    <ol
      className={styles.strip}
      aria-label={INTERFACE_TEXT.tsPartsLabel}
      style={{ gridTemplateColumns: `repeat(${strip.parts.length}, 1fr)` }}
      data-testid="parts-strip"
    >
      {strip.parts.map((p) => (
        <li
          key={p.id}
          className={`${styles.part} ${styles[p.state]}`}
          aria-current={p.state === 'current' ? 'step' : undefined}
          data-state={p.state}
        >
          <span className={styles.bar} aria-hidden="true" />
          <span className={styles.label}>{p.label}</span>
          <span className={styles.sr}>{`, ${STATE_TEXT[p.state]}`}</span>
        </li>
      ))}
    </ol>
  );
};

export default PartsStrip;
